import { CgProfile } from 'react-icons/cg';
import { RxCrossCircled } from 'react-icons/rx';

import { accountStatus } from '../utils/accountStatus';
import { subscriptionStatus } from '../utils/subscriptionStatus';
import { tableBackgroundColor } from '../utils/tableBackgroundColor';
import showUserRole from './showUserRole';

import { IUser } from '@/interfaces/entities/user';

interface UserTableContentProps {
	users: IUser[];
	openProfileModal: (user: IUser) => void;
}

const UsersTableContent = ({
	users,
	openProfileModal,
}: UserTableContentProps) => {
	return (
		<tbody className="divide-y divide-gray-200">
			{users.map((user, index) => (
				<tr
					key={user.id}
					className={`${tableBackgroundColor(index)} hover:bg-gray-200 min-h-8`}
					data-test="tr-user"
				>
					<td
						className="text-center py-4 px-3 text-sm font-medium text-gray-900 "
						data-test="td-id"
					>
						{user.id}
					</td>
					<td
						className="text-center  py-4 px-3 text-sm text-gray-500"
						data-test="td-name"
					>
						{user.firstName} {user.lastName}
					</td>
					<td
						className="text-center  py-4 px-3 text-sm text-gray-500"
						data-test="td-email"
					>
						{user.username}
					</td>
					<td
						className="text-center  py-4 px-3 text-sm text-gray-500"
						data-test="td-role"
					>
						{showUserRole(user.roles[0])}
					</td>
					<td
						className="text-center py-4 px-3 text-sm text-gray-500"
						data-test="td-profile"
					>
						<button
							className="text-center   text-gray-400 hover:text-gray-500"
							onClick={() => openProfileModal(user)}
						>
							<CgProfile size={22} />
						</button>
					</td>
					<td className="text-center px-3  py-4" data-test="td-status">
						{accountStatus(user)}
					</td>
					<td className="text-center px-3 py-4" data-test="td-subscription">
						{user?.subscription ? (
							subscriptionStatus(user)
						) : (
							<div className="text-center flex-col items-center justify-center">
								<RxCrossCircled
									className={`inline-block align-middle text-gray-500`}
									title="Not subscribed"
									size={22}
								/>
								<div className="text-xs text-gray-400 ml-2">
									No subscription
								</div>
							</div>
						)}
					</td>
				</tr>
			))}
		</tbody>
	);
};

export default UsersTableContent;
